import React from 'react'
import { Grid } from 'semantic-ui-react'
import { ActiveTransportForm } from './activeTransportForm'
import {CountryInfoForm} from './countryInfoForm'
import { GoodLocationForm } from './export/goodLocationForm'
import { InLandTransportForm } from './inLandTransportForm'
import { BorderTransportModeForm } from './borderTransportModeForm'
import { WareHouseDetailForm } from './wareHouseDetailForm'
import  RoutingCountry from './routingCountry'
import { TransportModeForm } from './transportModeForm'
import { SecurityInfoForm } from './securityInfoForm'
import { TerminalForm } from './terminalForm'


export const Transport=({children})=>{
return(
    <Grid  className="responsiveGridCss transportation">
        {children}
    </Grid>
)
}
Transport.GoodLocationForm=GoodLocationForm
Transport.BorderTransportModeForm=BorderTransportModeForm
Transport.WareHouseDetailForm=WareHouseDetailForm
Transport.CountryInfoForm=CountryInfoForm
Transport.InLandTransportForm=InLandTransportForm
Transport.ActiveTransportForm=ActiveTransportForm
Transport.RoutingCountry=RoutingCountry
Transport.TransportModeForm=TransportModeForm
Transport.SecurityInfoForm=SecurityInfoForm
Transport.TerminalForm=TerminalForm
